<template>
  <div class="proposals-item">
    <ul class="proposals-item-row">
      <li class="proposals-item-column">
        <p v-if="proposal.vehicle_model">
          {{ proposal.vehicle_model.brand }} {{ proposal.vehicle_model.name }}
        </p>

        <template v-else>
          Veículo desconhecido
        </template>
      </li>

      <li
        v-if="date"
        class="proposals-item-column"
      >
        {{ proposal.created_at | datetime }}
      </li>
    </ul>

    <ul class="proposals-item-row">
      <li class="proposals-item-column">
        {{ proposal.proposal_attempt.input_financing_in_cents | monetize }}

        <span class="proposals-item-nowrap">
          + {{ installments.quantity }}x
          {{ installments.value | monetize({ prefix: '' }) }}
        </span>
      </li>

      <li class="proposals-item-column">
        <span :class="status">
          {{ proposal.state | status }}
        </span>
      </li>
    </ul>

    <ul
      v-for="balloon in balloons"
      :key="balloon.value"
      class="proposals-item-row proposals-item-row-marginless"
    >
      <li class="proposals-item-column">
        + {{ balloon.quantity }}x {{ balloon.value | monetize({ prefix: '' }) }}
        ({{ (balloon.months.length > 1) ? 'meses' : 'mês' }} {{ balloon.months.join(', ') }})
      </li>
    </ul>

    <ul class="proposals-item-row">
      <li class="proposals-item-column proposals-item-nowrap">
        {{ proposal.seller && proposal.seller.name | namelize(2) }}
      </li>

      <li class="proposals-item-column">
        <b>
          {{ proposal.store.name }}
        </b>
      </li>
    </ul>
  </div>
</template>

<script>
  import { extractBalloons } from '@/views/Proposals/Form/helpers';

  export default {
    name: 'ProposalListItem',
    props: {
      proposal: {
        type: Object,
        default() {
          return {};
        },
      },
      date: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      extracted() {
        return extractBalloons(this.proposal.proposal_attempt);
      },
      balloons() {
        return this.extracted.balloons || [];
      },
      installments() {
        return this.extracted.installments;
      },
      status() {
        return `proposals-item-status proposals-item-nowrap content-color-${this.proposal.state}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@/assets/stylesheets/proposals/status.scss';

  .proposals-item-row {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    list-style: none;
    margin-top: $gutter-smaller;
  }

  .proposals-item-row-marginless {
    margin-top: 0;
  }

  .proposals-item-column {
    text-align: right;

    &:first-child {
      margin-right: $gutter;
      text-align: left;
    }

    &:first-child:last-child {
      margin-right: 0;
    }
  }

  .proposals-item-nowrap {
    white-space: nowrap;
  }

  .proposals-item-status {
    font-weight: var(--cordel-font-weight-bold);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      display: none;
    }
  }

  @each $status in $status-colors {
    $key: nth($status, 1);
    $value: nth($status, 2);

    .content-color-#{$key} {
      background-color: $value;
      color: $white;
      border: 4px solid $value;
      border-radius: var(--cordel-border-radius-pill);
    }
  }
</style>
